import React from 'react';
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

// let data = [
//   {name: 'May 2018', Count: 1},
//   {name: 'Now 2018', Count: 1},
//   {name: 'Dec 2018', Count: 2},
//   {name: 'Jan 2019', Count: 1},
// ];
class SimpleLineChart extends React.Component {
 

  render () {
    let data = this.props.data;
  	return (
    
      <ResponsiveContainer width={'100%'} height={265} >
          <LineChart data={data} margin={{top: 8, right: 40, left: 8, bottom: 24}}>
            <XAxis dataKey="name" dy={10} />
            <YAxis/>
            <CartesianGrid strokeDasharray="3 3" vertical={false}/>
            <Tooltip/>
            <Line connectNulls={true} type="monotone" dataKey="Count" stroke="#ff6b5c" dot={{fill: '#ff6b5c' }}/>
          </LineChart>
      </ResponsiveContainer>
    );
  }
}

export default SimpleLineChart;
